const statusMapping = {
  "01": "受理待ち",
  "02": "受理待ち",
  "03": "稟議・決裁結果待ち",
  "04": "課長代理確認待ち",
  "05": "課長代理確認待ち",
  "06": "上長承認待ち",
  "07": "上長承認待ち",
  "08": "通知待ち",
  "09": "通知待ち",
  "11": "完了",
  "12": "完了",
  "13": "完了",
  "14": "完了",
};

const data = [
  ["通知待ち", "完了"],
  [
    "受理待ち",
    "稟議・決裁結果待ち",
    "課長代理確認待ち",
    "上長承認待ち",
    "通知待ち",
    "完了",
  ],
  [
    "受理待ち",
    "稟議・決裁結果待ち",
    "課長代理確認待ち",
    "上長承認待ち",
    "完了",
  ],
  ["受理待ち", "課長代理確認待ち", "上長承認待ち", "通知待ち", "完了"],
  ["受理待ち", "課長代理確認待ち", "上長承認待ち", "完了"],
  ["完了"],
  ["取下済"],
  [
    "受理待ち",
    "稟議・決裁結果待ち",
    "課長代理確認待ち",
    "上長承認待ち",
    "通知待ち",
  ],
  ["差戻済"],
];

export { data, statusMapping };
